"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconKitchen = function SvgIconKitchen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "kitchen icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Kitchen Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 7.5a1.5 1.5 0 013 0V15a6.013 6.013 0 01-4 5.658.75.75 0 00-.5.706V40.5a1.5 1.5 0 01-3 0V21.364c0-.317-.2-.6-.5-.706A6.013 6.013 0 0112 15V7.5a1.5 1.5 0 013 0V15c0 .784.307 1.537.857 2.097a.376.376 0 00.643-.263V7.5a1.5 1.5 0 013 0v9.337a.377.377 0 00.643.263A2.99 2.99 0 0021 15V7.5zm7.5-.375c0-.621.504-1.125 1.125-1.125 3.498 0 7.029 9.082 7.125 19.864v.011a1.864 1.864 0 01-1.875 1.875H32.25a.75.75 0 00-.75.75v12a1.5 1.5 0 01-3 0V7.125z"
  }));
};

var _default = SvgIconKitchen;
exports.default = _default;